// Banner can be dismissed by clicking close, which sets a cookie so we know
// not to show it again.
$(document.body).on('click', '.js-maintenance-banner', function(e) {
  e.preventDefault();
  var $btn = $(this);

  var cookieName = $btn.data('cookie');
  var expiresEpoch = $btn.data('cookie-expires');
  var expirationTime = new Date(parseInt(expiresEpoch));
  Cookies.set(cookieName, '1', { expires: expirationTime });
});
